import React, {useEffect} from "react";
import {observer} from "mobx-react-lite";
import clubStore from '../../../storage/ClubStore'
import {useParams} from 'react-router'
import Branch from "./Branch";

const EditBranch = () => {
  const args = useParams();
  useEffect(() => {
    clubStore.getBranch(args.id)
  }, [args.id])
  return (
    <Branch/>
  );
};

export default observer(EditBranch);